import { ApiCollectionResponse, NotificationItem, Params } from 'types';

import { getCollectionResponse, request } from '../config';

const GET_NOTIFICATIONS_URL = "/notifications.json";
const NOTIFICATIONS_URL = "/notifications";

export function getNotifications(
  params: Params
): Promise<ApiCollectionResponse<NotificationItem>> {
  return request(
    {
      url: GET_NOTIFICATIONS_URL,
      method: "GET",
      params: params,
    },
    (data) => {
      return getCollectionResponse<NotificationItem>(data);
    }
  );
}

export function markNotificationRead(
  id: String
): Promise<NotificationItem> {
  return request(
    {
      url: `${NOTIFICATIONS_URL}/${id}/mark-read.json`,
      method: "PATCH",
    },
    (data) => data.model
  );
}
